export default __webpack_public_path__ + "static/media/avatar_nikki_dog6.dae77892.mp3";